<template>
	<span class="menu-svg-icon" aria-hidden="true" v-html="icons[name]"></span>
</template>

<script>
import calendar from '@/assets/icons/appointments/calendar.svg?raw';
import chevronLeft from '@/assets/icons/appointments/chevron-left.svg?raw';
import exit from '@/assets/icons/appointments/exit.svg?raw';
import basket from '@/assets/icons/menu/basket.svg?raw';
import invoiceUp from '@/assets/icons/menu/invoice-up.svg?raw';
import invoiceDown from '@/assets/icons/menu/invoice-down.svg?raw';
import document from '@/assets/icons/menu/document.svg?raw';
import chart from '@/assets/icons/menu/chart.svg?raw';
import folder from '@/assets/icons/menu/folder.svg?raw';
import settings from '@/assets/icons/menu/settings.svg?raw';

// Only trusted local SVGs; shared symbols have a single source in the Appointments set.
const icons = { calendar, 'chevron-left': chevronLeft, exit, basket, 'invoice-up': invoiceUp, 'invoice-down': invoiceDown, document, chart, folder, settings };
</script>

<script setup>
defineProps({ name: { type: String, required: true, validator: name => Object.hasOwn(icons, name) } });
</script>

<style scoped>
.menu-svg-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 1em;
	height: 1em;
	flex: none;
	vertical-align: middle;
	line-height: 0;
	pointer-events: none;
}
.menu-svg-icon :deep(svg) {
	display: block;
	width: 100%;
	height: 100%;
}
</style>
